import { uploadAttachment } from '@/services/bff/attachment.api';
import { createAppRequest } from '@/services/request';
import { crmAttachmentPath } from './content';

const request = createAppRequest();
export async function uploadMarkdownFile(
  file: File,
  bizType?: string,
  bizUuid?: string,
) {
  if (!bizType || !bizUuid) throw new Error('请先选择关联业务对象，再上传文件');
  if (file.size > 20 * 1024 * 1024) throw new Error('文件不能超过 20 MB');
  const result = await uploadAttachment({
    file,
    bizType,
    bizUuid,
    remark: '跟进记录附件',
  });
  return `/bff/zy-crm/attachments/${result.uuid}/content?${new URLSearchParams({ bizType, bizUuid })}`;
}

export async function loadMarkdownFile(url: string) {
  const path = crmAttachmentPath(url);
  if (!path) return url;
  const blob = await request<Blob>(path, {
    method: 'GET',
    responseType: 'blob',
  });
  return URL.createObjectURL(blob);
}
